
export default {
  props: {
    href: { type: String, default: null },
    label: { type: String, default: 'voir' },
    theme: { type: String, default: null },
    noLabel: { type: Boolean, default: false },
  },
}
